export default __webpack_public_path__ + "static/media/Horne FL 7.c99d4f87.JPEG";